// extracted by mini-css-extract-plugin
export default {"es":"logoText-module--es--If8hU","pt":"logoText-module--pt--5f4-F"};